import type { ModalResult } from './generic-modal';
export * from './generic-modal';

export function showModal(elName: keyof HTMLElementTagNameMap): Promise<ModalResult> {
  const modal = document.createElement(elName) as HTMLGenericModalElement;

  /* if (config) {
    config(modal);
  } */

  document.body.appendChild(modal);

  return modal.show();
}
